const DUMMY_EXPENCES = [
  //1200 wali starts_____________________________________________
    {
      id: 'B_1200_1',
      title: 'TRADITIONAL YELLOW COLORED TEXTURED BANGLE & BRACELET',
      rating : 2,
      amountold: 1300,
      amount: 1200,
      //<a href="https://ibb.co/dK4G8Tp"><img src="https://i.ibb.co/WKvgmhz/RS-1200-1.jpg" alt="RS-1200-1" border="0"></a>
      src: 'https://i.ibb.co/WKvgmhz/RS-1200-1.jpg'
    },
  
    {
      id: 'B_1200_2',
      title: 'TRADITIONAL BLUE VIOLET COLORED TEXTURED BANGLE & BRACELET',
      rating : 5,
      amountold: 1300,
      amount: 1200,
      //<a href="https://ibb.co/yPfbgwQ"><img src="https://i.ibb.co/mTDMhLc/RS-1200-2.jpg" alt="RS-1200-2" border="0"></a>
      src: 'https://i.ibb.co/mTDMhLc/RS-1200-2.jpg'
    },
    {
      id: 'B_1200_3',
      title: 'TRADITIONAL LIME COLORED TEXTURED BANGLE & BRACELET',
      rating : 5,
      amountold: 1300,
      amount: 1200,
      //<a href="https://ibb.co/RHqB2Z6"><img src="https://i.ibb.co/Jk9yn0p/RS-1200-3.jpg" alt="RS-1200-3" border="0"></a>
      src: 'https://i.ibb.co/Jk9yn0p/RS-1200-3.jpg'
    },
    {
      id: 'B_1200_4',
      title: 'TRADITIONAL RED COLORED TEXTURED BANGLE & BRACELET',
      rating : 3,
      amountold: 1300,
      amount: 1200,
      //<a href="https://ibb.co/G9QkG2D"><img src="https://i.ibb.co/w7hC8Wq/RS-1200-4.jpg" alt="RS-1200-4" border="0"></a>
      src: 'https://i.ibb.co/w7hC8Wq/RS-1200-4.jpg'
    },
    {
      id: 'B_1200_5',
      title: 'TRADITIONAL PEACH COLORED TEXTURED BANGLE & BRACELET',
      rating : 3,
      amountold: 1300,
      amount: 1200,
      //<a href="https://ibb.co/fdGV7Tq"><img src="https://i.ibb.co/GQ3fjrn/RS-1200-5.jpg" alt="RS-1200-5" border="0"></a>
      src: 'https://i.ibb.co/GQ3fjrn/RS-1200-5.jpg'
    },
    {
      id: 'B_1200_6',
      title: 'TRADITIONAL GOLDEN COLORED TEXTURED BANGLE & BRACELET',
      rating : 3,
      amountold: 1300,
      amount: 1200,
      //<a href="https://ibb.co/ZGSCJ7b"><img src="https://i.ibb.co/q7CwnV2/RS-1200-6.jpg" alt="RS-1200-6" border="0"></a>
      src: 'https://i.ibb.co/q7CwnV2/RS-1200-6.jpg'
    },
    {
      id: 'B_1200_7',
      title: 'TRADITIONAL PINK COLORED TEXTURED BANGLE & BRACELET',
      rating : 5,
      amountold: 1300,
      amount: 1200,
      // <a href="https://ibb.co/VV8cgGX"><img src="https://i.ibb.co/Q9G3PVs/RS-1200-7.jpg" alt="RS-1200-7" border="0"></a>
      src: 'https://i.ibb.co/Q9G3PVs/RS-1200-7.jpg'
    },  {
      id: 'B_1200_8',
      title: 'TRADITIONAL MAROON COLORED TEXTURED BANGLE & BRACELET',
      rating : 4,
      amountold: 1300,
      amount: 1200,
    
      src: 'https://i.ibb.co/v3rNNgL/RS-1200-8.jpg'
    },  {
      id: 'B_1200_9',
      title: 'TRADITIONAL DARK GREEN COLORED TEXTURED BANGLE & BRACELET',
      rating : 4,
      amountold: 1300,
      amount: 1200,
      //<a href="https://ibb.co/y0YDw9j"><img src="https://i.ibb.co/7vRHwfm/RS-1200-9.jpg" alt="RS-1200-9" border="0"></a>
      src: 'https://i.ibb.co/7vRHwfm/RS-1200-9.jpg'
    },
 
    {
        //1200 wali ends__________________________900 wali starts
      id: 'B_900_1',
      title: 'TRADITIONAL RUBY ETHNIC BANGLE SET ',
      rating : 5,  
      amountold: 950, 
      amount: 900,
    //<a href="https://ibb.co/bR0vptq"><img src="https://i.ibb.co/M5v1qdW/RS-900-1.jpg" alt="RS-900-1" border="0"></a>
      src: 'https://i.ibb.co/M5v1qdW/RS-900-1.jpg'
  
    },
    {
      id: 'B_900_2',
      title: 'TRADITIONAL MINT ETHNIC BANGLE SET ',
      rating : 5,
      amountold: 950, 
      amount: 900,
      
      src: 'https://i.ibb.co/Y0FWyFv/RS-900-2.jpg'
    },
    {
      id: 'B_900_3',
      title: 'TRADITIONAL CYAN ETHNIC BANGLE SET ',
      rating : 5,
      amountold: 950, 
      amount: 900,
      //<a href="https://ibb.co/0hys5c6"><img src="https://i.ibb.co/18GzcLP/RS-900-3.jpg" alt="RS-900-3" border="0"></a>
      src: 'https://i.ibb.co/18GzcLP/RS-900-3.jpg'
    },
    {
      id: 'B_900_4',
      title: 'TRADITIONAL YELLOW ETHNIC BANGLE SET ',
      rating : 4,
      amountold: 950, 
      amount: 900,
      //<a href="https://ibb.co/n7C0DRg"><img src="https://i.ibb.co/D9pb7LV/RS-900-4.jpg" alt="RS-900-4" border="0"></a>
      src: 'https://i.ibb.co/D9pb7LV/RS-900-4.jpg'
    },
    {
      id: 'B_900_5',
      title: 'TRADITIONAL MAUVE ETHNIC BANGLE SET',
      rating : 4,
      amountold: 950, 
      amount: 900,
      //<a href="https://ibb.co/1qm0dfq"><img src="https://i.ibb.co/qsrDWMs/RS-900-5.jpg" alt="RS-900-5" border="0"></a>
      src: 'https://i.ibb.co/qsrDWMs/RS-900-5.jpg'
    },
    {
      id: 'B_900_6',
      title: 'TRADITIONAL DARK MAUVE ETHNIC BANGLE SET ',
      rating : 5,
      amountold: 950, 
      amount: 900,
      //<a href="https://ibb.co/smZb5Ff"><img src="https://i.ibb.co/RvqYhCF/RS-900-6.jpg" alt="RS-900-6" border="0"></a>
      src: 'https://i.ibb.co/RvqYhCF/RS-900-6.jpg'
    },
    {
      id: 'B_900_7',
      title: 'TRADITIONAL NAVY BLUE ETHNIC BANGLE SET ',
      rating : 5,
      amountold: 950, 
      amount: 900,
      //<a href="https://ibb.co/Sy6nDMZ"><img src="https://i.ibb.co/NCFjgJG/RS-900-7.jpg" alt="RS-900-7" border="0"></a>
      src: 'https://i.ibb.co/NCFjgJG/RS-900-7.jpg'
    },
    {
      id: 'B_900_8',
      title: 'TRADITIONAL DARK GREEN ETHNIC BANGLE SET ',
      rating : 5,
      amountold: 950, 
      amount: 900,
      //<a href="https://ibb.co/RzHzj0Q"><img src="https://i.ibb.co/NZYZTjW/RS-900-8.jpg" alt="RS-900-8" border="0"></a>
      src: 'https://i.ibb.co/NZYZTjW/RS-900-8.jpg'
    },  
  {
      id: 'B_900_9',
      title: 'TRADITIONAL LAVISH PINK ETHNIC BANGLE SET ',
      rating : 5,
      amountold: 950, 
      amount: 900,
      //<a href="https://ibb.co/6wfvVX3"><img src="https://i.ibb.co/qjP0XJt/RS-900-9.jpg" alt="RS-900-9" border="0"></a>
      src: 'https://i.ibb.co/qjP0XJt/RS-900-9.jpg'
    },
  //900 WALI ENDS____________________800 WALI STARTS 
  
    {
      id: 'B_800_1',
      title: 'ETHNIC GOLDEN INDIGO SHINING BANGLE ',
      rating : 5,
      amountold: 850, 
      amount: 800,
      //<a href="https://ibb.co/JqFqXX2"><img src="https://i.ibb.co/RN4NLLP/RS-800-1.jpg" alt="RS-800-1" border="0"></a>
      src: 'https://i.ibb.co/RN4NLLP/RS-800-1.jpg'
    },
  {
      id: 'B_800_2',
      title: 'ETHNIC GOLDEN  VIOLET SHINING BANGLE ',
      rating : 5,
      amountold: 850, 
      amount: 800,
      //<a href="https://ibb.co/xD5xZTJ"><img src="https://i.ibb.co/t4CVRr8/RS-800-2.jpg" alt="RS-800-2" border="0"></a>
      src: 'https://i.ibb.co/t4CVRr8/RS-800-2.jpg'
    },
  {
      id: 'B_800_3',
      title: 'ETHNIC GOLDEN CREAM SHINING BANGLE ',
      rating : 5,
      amountold: 850, 
      amount: 800,
      //<a href="https://ibb.co/PMXKStm"><img src="https://i.ibb.co/gdqNn6j/RS-800-3.jpg" alt="RS-800-3" border="0"></a>
      src: 'https://i.ibb.co/gdqNn6j/RS-800-3.jpg'
    },
  {
      id: 'B_800_4',
      title: 'ETHNIC GOLDEN YELLOW SHINING BANGLE ',
      rating : 5,
      amountold: 850, 
      amount: 800,
      //<a href="https://ibb.co/g9db2PN"><img src="https://i.ibb.co/B3GHprb/RS-800-4.jpg" alt="RS-800-4" border="0"></a>
      src: 'https://i.ibb.co/B3GHprb/RS-800-4.jpg'
    },
  {
      id: 'B_800_5',
      title: 'ETHNIC GOLDEN MAGENTA SHINING BANGLE ',
      rating : 4,
      amountold: 850, 
      amount: 800,
      //<a href="https://ibb.co/k86nGhP"><img src="https://i.ibb.co/Lthw0Cs/RS-800-5.jpg" alt="RS-800-5" border="0"></a>
      src: 'https://i.ibb.co/Lthw0Cs/RS-800-5.jpg'
    },{
      id: 'B_800_6',
      title: 'ETHNIC  GOLDEN PINK SHINING BANGLE ',
      rating : 5,
      amountold: 850, 
      amount: 800,
      //<a href="https://ibb.co/59RXxZh"><img src="https://i.ibb.co/JdsWFZj/RS-800-6.jpg" alt="RS-800-6" border="0"></a>
      src: 'https://i.ibb.co/JdsWFZj/RS-800-6.jpg'
    },{
      id: 'B_800_7',
      title: 'ETHNIC GOLDEN ORANGE SHINING BANGLE ',
      rating : 4,
      amountold: 950, 
      amount: 850,
      //<a href="https://ibb.co/cg3Jc0g"><img src="https://i.ibb.co/6nwYRzn/RS-800-7.jpg" alt="RS-800-7" border="0"></a>
      src: 'https://i.ibb.co/6nwYRzn/RS-800-7.jpg'
    },{
      id: 'B_800_8',
      title: 'ETHNIC GOLDEN CYAN SHINING BANGLE ',
      rating : 5,
      amountold: 850, 
      amount: 800,
      //<a href="https://ibb.co/tp5FWp9"><img src="https://i.ibb.co/VY85PYs/RS-800-8.jpg" alt="RS-800-8" border="0"></a>
      src: 'https://i.ibb.co/VY85PYs/RS-800-8.jpg'
    },
  
  //ENDS 800 WALI  ____________600 WALI STARTS 
  
    {
      id: 'B_600_1',
      title: 'DAILY WEAR RED BANGLE BRACLET SET',
      rating : 5,
      amountold: 650,
      amount: 600,
      //<a href="https://ibb.co/m4BVVSp"><img src="https://i.ibb.co/CQt33WL/RS-600-1.jpg" alt="RS-600-1" border="0"></a>
      src: 'https://i.ibb.co/CQt33WL/RS-600-1.jpg'
    },
    {
      id: 'B_600_2',
      title: 'DAILY WEAR CHARCOL BANGLE BRACLET SET',
      rating : 5,
      amountold: 650,
      amount: 600,
      //<a href="https://ibb.co/5kpHY1v"><img src="https://i.ibb.co/KD4vN57/RS-600-2.jpg" alt="RS-600-2" border="0"></a>
      src: 'https://i.ibb.co/KD4vN57/RS-600-2.jpg'
    },
    {
      id: 'B_600_3',
      title: 'DAILY WEAR MAROON BANGLE BRACLET SET',
      rating : 5,
      amountold: 650,
      amount: 600,
      //<a href="https://ibb.co/RBxFXJj"><img src="https://i.ibb.co/fnhg3TD/RS-600-3.jpg" alt="RS-600-3" border="0"></a>
      src: 'https://i.ibb.co/fnhg3TD/RS-600-3.jpg'
    },
    {
      id: 'B_600_4',
      title: 'DAILY WEAR TAN BANGLE BRACLET SET',
      rating : 3,
      amountold: 650,
      amount: 600,
      //<a href="https://ibb.co/sgB1sXg"> <img src="https://i.ibb.co/mRxyhPR/RS-600-4.jpg" alt="RS-600-4" border="0"></a>
      src: 'https://i.ibb.co/mRxyhPR/RS-600-4.jpg'
    },
    {
      id: 'B_600_5',
      title: 'DAILY WEAR YELLOW BANGLE BRACLET SET',
      rating : 5,
      amountold: 650,
      amount: 600,
      //<a href="https://ibb.co/JRTfT7X"><img src="https://i.ibb.co/C5yky7x/RS-600-5.jpg" alt="RS-600-5" border="0"></a>
      src: 'https://i.ibb.co/C5yky7x/RS-600-5.jpg'
    },
    {
      id: 'B_600_6',
      title: 'DAILY WEAR CORAL BANGLE BRACLET SET',
      rating : 5,
      amountold: 650,
      amount: 600,
      // <a href="https://ibb.co/6XHsPvt"><img src="https://i.ibb.co/SftvnQm/RS-600-6.jpg" alt="RS-600-6" border="0"></a>
     src: 'https://i.ibb.co/SftvnQm/RS-600-6.jpg'
    },
  //600 WALI ENDS ________________________________________
  ]
  export default DUMMY_EXPENCES